import { render, staticRenderFns } from "./mobile-number-type.vue?vue&type=template&id=1f1e8ee9&scoped=true&"
import script from "./mobile-number-type.vue?vue&type=script&lang=ts&"
export * from "./mobile-number-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e8ee9",
  null
  
)

export default component.exports